import { render, staticRenderFns } from "./PendingTaskItem.vue?vue&type=template&id=56c3812a"
import script from "./PendingTaskItem.vue?vue&type=script&lang=js"
export * from "./PendingTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports